import styles from './Label.module.scss';

const Label = (props) => 
{
    return (                
        <button onClick= {props.trigger} type={props.type} className={styles.Label} style={{color: props.color, fontSize: props.fontSize, fontFamily: props.font, fontWeight: props.weight}}>{props.children}</button>                
    );
}

export default Label;